import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const ACCESS_ZERO_HERO_IMAGE = svgToTinyDataUri(
  `<svg width="400" height="300" viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="400" height="300" fill="#f0f0f0"/>
  <text x="200" y="150" text-anchor="middle" dominant-baseline="middle" fill="#666" font-size="20">Access ZERO Image</text>
  </svg>`
);
